import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { TeamMemberCard } from '../components/TeamMemberCard';
import { CtaBand } from '../components/CtaBand';
import { team } from '../data/team';
const EASE = [0.23, 1, 0.32, 1] as const;
const ALL = 'Iedereen';
export function Team() {
  const [filter, setFilter] = useState<string>(ALL);
  const groups = filter === ALL ? team : team.filter(g => g.title === filter);
  return <>
      <PageHeader title="Ons team" crumbs={[{
      label: 'Over ons',
      to: '/over-ons'
    }, {
      label: 'Ons team'
    }]} intro="De behandelingen worden uitgevoerd door anesthesioloog-pijnspecialisten en (pijn)verpleegkundigen, ondersteund door ons secretariaat, management en financiële team." data-id="element-732" data-mp="12ed14kfvmn0g" />

      <div className="sticky top-[76px] z-20 border-b border-line bg-white xl:top-[116px]" data-id="element-733" data-mp="2huvhgkpcdt1j">
        <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-734" data-mp="2mswwmujnd87q">
          <div className="scrollbar-none -mx-5 -mb-px flex gap-6 overflow-x-auto px-5 lg:mx-0 lg:px-0" role="tablist" aria-label="Team" data-id="element-735" data-mp="2a5wyze9lbr7j">
            {[ALL, ...team.map(g => g.title)].map(title => <button key={title} type="button" role="tab" aria-selected={filter === title} onClick={() => setFilter(title)} className={`shrink-0 whitespace-nowrap border-b-2 py-4 text-[15px] font-medium transition-colors duration-150 ${filter === title ? 'border-primary text-primary' : 'border-transparent text-muted hover:text-ink'}`} data-id="element-736" data-mp="2jwrpwvxs7ezb">
                {title}
              </button>)}
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8 lg:py-20" data-id="element-737" data-mp="3bn5vm4vn5kzw">
        <AnimatePresence mode="wait" initial={false} data-id="element-738" data-mp="3bpijeyo2ypkv">
          <motion.div key={filter} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2,
          ease: EASE
        }} className="space-y-20" data-id="element-739" data-mp="37ksrfkwjlv58">
            {groups.map(group => <section key={group.title} aria-labelledby={`team-${group.title}`} data-id="element-740" data-mp="2eafi6qm2p1sr">
                <div className="flex items-baseline justify-between gap-4 border-b border-line pb-4" data-id="element-741" data-mp="2iazcznj6btbq">
                  <h2 id={`team-${group.title}`} className="font-display text-2xl font-semibold text-ink sm:text-3xl" data-id="element-742" data-mp="1lli28u5c3h36">
                    {group.title}
                  </h2>
                  <span className="text-sm text-muted" data-id="element-743" data-mp="1uldel2amli4s">{group.members.length} medewerkers</span>
                </div>
                <ul className="mt-8 grid grid-cols-2 gap-x-5 gap-y-10 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5" data-id="element-744" data-mp="1zc3kqhqvlp0j">
                  {group.members.map(m => <li key={m.name} data-id="element-745" data-mp="16vj4utlls9or">
                      <TeamMemberCard member={m} data-id="element-746" data-mp="16uhjnwavi6tb" />
                    </li>)}
                </ul>
              </section>)}
          </motion.div>
        </AnimatePresence>
      </div>

      <CtaBand data-id="element-747" data-mp="ue8dkireqhpt" />
    </>;
}